<template>
  <div
    class="illustrative-links__block"
    @click="simulateClickOnLink"
  >
    <div class="illustrative-links__icon-wrapper">
      <svgicon
        :name="icon"
        :original="true"
        class="illustrative-links__icon"
      />
    </div>
    <a
      ref="illustrativeBlockLink"
      :href="url"
      class="illustrative-links__link"
      @click.stop
    >
      {{ text }}
    </a>
  </div>
</template>
<script>

export default {
  name: "IllustrativeLinks",
  props: {
    text: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
  },
    methods: {
    simulateClickOnLink () {
      this.$refs.illustrativeBlockLink.click()
    },
  },
 }
</script>
<style lang="scss">

.illustrative-links {
  &__block {
    text-decoration: none;
    align-items: center;
    display: inline-flex;
    flex-direction: column;

    @include font(text,3, "bold");

    &:hover,
    &:active {
      cursor: pointer;

      .illustrative-links__link {
        color: $color-pink-light;
      }
    }
  }

  &__icon-wrapper {
    width: 80px;
    height: 80px;
    background: $color-red-special;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__icon {
    width: 3rem;
    height: 3rem;
  }
}

</style>



